import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"
import { Checkbox } from "@/components/ui/checkbox"
import { SHORTCUTS } from "../../hooks/useKeyboardShortcuts"

interface ShortcutsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  enabled: boolean
  onEnabledChange: (enabled: boolean) => void
  /** Las cuentas grupales no tienen «Mis cursos»; se omite ese atajo. */
  isStudent?: boolean
}

export default function ShortcutsDialog({ open, onOpenChange, enabled, onEnabledChange, isStudent = true }: ShortcutsDialogProps) {
  const shortcuts = SHORTCUTS.filter((shortcut) => isStudent || !shortcut.studentOnly)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Atajos de teclado</DialogTitle>
          <DialogDescription>
            Funcionan fuera de los campos de texto. Para ir a una página, pulsa «g» y luego la letra.
          </DialogDescription>
        </DialogHeader>
        <ul className="divide-y divide-border">
          {shortcuts.map((shortcut) => (
            <li key={shortcut.label} className="flex items-center justify-between gap-4 py-2.5 text-sm">
              <span className="text-foreground">{shortcut.label}</span>
              <span className="flex items-center gap-1">
                {shortcut.keys.map((key, index) => (
                  <span key={`${key}-${index}`} className="flex items-center gap-1">
                    {index > 0 && <span className="text-xs text-muted-foreground">luego</span>}
                    <kbd className="min-w-6 rounded-md border border-border bg-muted px-1.5 py-0.5 text-center text-xs font-semibold text-foreground">
                      {key}
                    </kbd>
                  </span>
                ))}
              </span>
            </li>
          ))}
        </ul>
        <div className="border-t border-border pt-4">
          <label className="flex min-h-11 cursor-pointer items-center gap-3 text-sm font-medium text-foreground sm:min-h-0">
            <Checkbox checked={enabled} onCheckedChange={(value) => onEnabledChange(value === true)} />
            Atajos de teclado activados
          </label>
          <p className="mt-1 pl-7 text-xs text-muted-foreground">Los atajos de una tecla pueden desactivarse.</p>
        </div>
      </DialogContent>
    </Dialog>
  )
}
